import { mutationTypes } from '@/types';
import { router } from '@/router';

const PRESERVED_URL_VARS = [
	'mode',
	'ds',
	'css',
	'app',
	'showLogMessages',
	'isPreviewDataSource',
	'isVirtualPackageSyncer',
	'pageTransition',
	'plugin',
	'pluginName',
];

export default async function pushUrl({ state, commit }, { url, replace }) {
	commit(mutationTypes.setRouteChangedByClick, { routeUserClicked: true });
	// Preserve url vars.
	const parts = url.split('?');
	const urlVars = parts[1] ? parts[1].split('&').map((s) => s.split('=')) : [];
	const urlVarsKeys = urlVars.map((v) => v[0]);
	const perservedEntries = Object.entries(state.route.query).filter(
		(entry) => PRESERVED_URL_VARS.includes(entry[0]) && !urlVarsKeys.includes(entry[0])
	);
	const urlWithVars = `${parts[0]}?${urlVars
		.concat(perservedEntries)
		.map((e) => (e[1] ? e.join('=') : e[0]))
		.join('&')}`;
	try {
		if (replace) await router.replace(urlWithVars);
		// If the router redirects the promise is rejected see https://github.com/vuejs/vue-router/issues/2932
		// we do not want to have uncaught promise rejections in this case, we just ignore it.
		else await router.push({ path: urlWithVars }).catch(() => {});
	} catch (error) {
		// vue-router throws an error if you try to replace with the same url
		if (!error || !error.name || error.name !== 'NavigationDuplicated') {
			throw error;
		}
	}
}
